import { render, staticRenderFns } from "./SkupPrometDetails.vue?vue&type=template&id=3573cb84&scoped=true&"
import script from "./SkupPrometDetails.vue?vue&type=script&lang=js&"
export * from "./SkupPrometDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573cb84",
  null
  
)

export default component.exports